import {
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddGenericStructure,
} from '@vi-iot/client';
import { RemoteDiagnosticsVddListParameter } from '@store';
import {
  DataKeyValues,
  DopnameValues,
  LongnameValues,
  NameValues,
  SemanticValues,
  VDDParameterViewValue,
} from './diagnostics-constants';

export namespace DiagnosticsHelpers {
  export function includesElementsInKey(
    data: RemoteDiagnosticsVddGenericStructure,
    searchKey: string,
    searchElements: string[]
  ): boolean {
    return searchElements.some((searchElement) => data?.[searchKey]?.includes(searchElement));
  }

  export function equalsElementsInKey(
    data: RemoteDiagnosticsVddGenericStructure,
    equalKey: string,
    searchElements: string[]
  ): boolean {
    return searchElements.some((searchElement) => data?.[equalKey] === searchElement);
  }

  export function isStructureIpAddressType(
    structure: RemoteDiagnosticsVddGenericStructure
  ): boolean {
    return (
      includesElementsInKey(structure, DataKeyValues.Dopname, [DopnameValues.IpAddress]) ||
      equalsElementsInKey(structure, DataKeyValues.Semantic, [SemanticValues.IP])
    );
  }

  export function isStructureMacAddressType(
    structure: RemoteDiagnosticsVddGenericStructure
  ): boolean {
    return (
      includesElementsInKey(structure, DataKeyValues.Dopname, [DopnameValues.MacAddress]) ||
      equalsElementsInKey(structure, DataKeyValues.Semantic, [SemanticValues.MAC])
    );
  }

  export function getStartStopTempStructure(
    rawSingleReadValues: RemoteDiagnosticsSuccessResponseData
  ): RemoteDiagnosticsVddGenericStructure[] {
    const dataRecorStructure = getDataRecorStructure(rawSingleReadValues);
    const startStopTemp = dataRecorStructure.structure.find(
      (value) => value.semantic === SemanticValues.STARTSTOPTEMP
    );

    return startStopTemp.structure;
  }

  export function getEntriesStructure(
    rawSingleReadValues: RemoteDiagnosticsSuccessResponseData
  ): RemoteDiagnosticsVddGenericStructure {
    const dataRecorStructure = getDataRecorStructure(rawSingleReadValues);

    return dataRecorStructure.structure.find(
      (structure) => structure.semantic === SemanticValues.ENTRIES
    );
  }

  export function getDataRecorStructure(
    rawSingleReadValues: RemoteDiagnosticsSuccessResponseData
  ): RemoteDiagnosticsVddGenericStructure {
    const dataRecorStructure = rawSingleReadValues.structure.find(
      (structureValue) => structureValue.name === NameValues.DataRecor
    );

    return dataRecorStructure;
  }

  export function mapVDDListToDisplay(
    parameters: RemoteDiagnosticsVddListParameter[]
  ): VDDParameterViewValue[] {
    return parameters.map((parameter) => ({
      value: parameter.name,
      viewValue: parameter.value,
      viewValueTwo: parameter.vddInterval,
      viewValueThree: parameter.name,
      isWrite: parameter.isWrite,
      isRead: parameter.isRead,
    }));
  }

  export function isVddSensorFromStructure(
    structure: RemoteDiagnosticsVddGenericStructure
  ): boolean {
    if (Array.isArray(structure?.structure?.[0]?.structure)) {
      const prefixStructure = structure.structure[0].structure.find(
        (structureValue) => structureValue.longname === LongnameValues.Structure
      );

      return prefixStructure ? isVddSensor(prefixStructure) : false;
    } else {
      return false;
    }
  }

  export function isVddSensor(structure: any): boolean {
    const sensor = structure?.structure?.find(
      (dataStructure) =>
        (dataStructure.path === NameValues.DataRecorValue ||
          dataStructure.path === NameValues.DataStrucValue) &&
        dataStructure.semantic === SemanticValues.SENSORVALUE
    );

    return !!sensor;
  }
}
